import NAVBAR from "components/navbar";

function MeuDesconto(){
    return <div>
        <NAVBAR />
        <h1>Meu Desconto</h1>
    </div>
}

export default MeuDesconto;